module.exports = __webpack_public_path__ + "static/media/posts-6.194b4c0b.jpg";